import { Helmet } from 'react-helmet';
import { AddNewCarrier } from '../components/AddNewCarrier';

const AddNewCarrierPagePage = () => (
  <>
    <Helmet>
      <title> Add New Restaurant</title>
    </Helmet>

    <AddNewCarrier />
  </>
);

export default AddNewCarrierPagePage;
